export default "__VITE_ASSET__X5anp3oI__"